import get from 'transmute/get';
import { CHANNEL_ID, ID, INSTANCE_DELIVERY_IDENTIFIER, IS_ACTIVE, IS_AUTHORIZED, NAME } from '../constants/keyPaths';
export const getChannelId = get(CHANNEL_ID);
export const getId = get(ID);
export const getInstanceDeliveryIdentifier = get(INSTANCE_DELIVERY_IDENTIFIER);
export const getIsActive = get(IS_ACTIVE);
export const getIsAuthorized = get(IS_AUTHORIZED);
export const getName = get(NAME);